import { FunctionComponent, useEffect, useMemo } from 'react';
import React from 'react';
import { IWidgetConclusionProps } from './types';
import { UserRecaps } from './UserRecaps';
import { useSelect, useSelectWithParams } from '../../../../../utils/selector.utils';
import { OtherComments } from './OtherComments';
import { useDispatch } from 'react-redux';
import { setupConclusions } from '../../../../../app/page/page-storage/conclusions/conclusions.actions';
import { NonMeetingUsers } from './NonMeetingUsers';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { authSelectors } from '../../../../../app/auth/auth.selectors';

export const WidgetConclusion: FunctionComponent<IWidgetConclusionProps> = ({ meetingId, sessionId }) => {
  const loggedUserId = useSelect(authSelectors.selectLoggedUser);
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);

  const userIds = useMemo(
    () =>
      meeting
        ? [...meeting.shareWithIds, ...meeting.administratorIds].filter((value, index, self) => {
            return self.indexOf(value) === index;
          })
        : [],
    [meeting],
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setupConclusions(sessionId));
  }, [dispatch, sessionId]);

  if (loggedUserId === null) {
    return null;
  }

  return (
    <>
      <UserRecaps userIds={userIds} sessionId={sessionId} loggedUserId={loggedUserId} />
      <div style={{ display: 'flex' }}>
        <OtherComments sessionId={sessionId} loggedUserId={loggedUserId} />
        <NonMeetingUsers sessionId={sessionId} loggedUserId={loggedUserId} />
      </div>
    </>
  );
};
